var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicatCom"},[_c('div',{staticClass:"indicatbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.config.show),expression:"config.show"}],staticClass:"wz_content clearFloat"},[(_vm.config.iconSet.show)?_c('i',{staticClass:"iconfont",class:_vm.config.iconSet.name,style:({
                   width:_vm.config.iconSet.fontSize+'px',
                   fontSize:_vm.config.iconSet.fontSize+'px',
                   float:_vm.config.iconSet.position,
                   color:_vm.config.iconSet.color,
                   lineHeight:_vm.config.iconSet.lineHeight+'px',
            })}):_vm._e(),_c('div',{style:({
                  width:_vm.config.iconSet.show ? 'calc(100% - '+_vm.config.iconSet.fontSize+'px)':'100%',
                  paddingLeft:_vm.config.textSet.paddingLeft+'px',
                  paddingRight:_vm.config.textSet.paddingRight+'px',
                  float: _vm.config.iconSet.show ? 'right':'left'
            })},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.config.textSet.show),expression:"config.textSet.show"}],style:({
                        color:_vm.config.textSet.font.color,
                        fontSize:_vm.config.textSet.font.fontSize+'px',
                        fontWeight:_vm.config.textSet.font.fontWeight,
                        fontFamily:_vm.config.textSet.font.fontFamily,
                        top:_vm.config.paddingTop+'px',
                         width: 'calc(100% - ' + _vm.config.textSet.paddingLeft+'px - ' + _vm.config.textSet.paddingRight + 'px) ',
                        textAlign:_vm.config.textSet.position
                    })},[_vm._v(_vm._s(_vm.config.textSet.text))]),_c('p',{style:({
                         bottom:_vm.config.paddingBottom+'px',
                        width: 'calc(100% - ' + _vm.config.textSet.paddingLeft+'px - ' + _vm.config.textSet.paddingRight + 'px) ',
                         textAlign:_vm.config.valSet.position
                    })},[_c('span',{style:({
                        color:_vm.config.valSet.font.color,
                        fontSize:_vm.config.valSet.font.fontSize+'px',
                        fontWeight:_vm.config.valSet.font.fontWeight,
                        fontFamily:_vm.config.valSet.font.fontFamily,
                    })},[_vm._v(_vm._s(_vm.config.valSet.val))])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }